import GenericDB from './generic-db'

export default class AccountClientCampaignAdzDB extends GenericDB {
  constructor(accountId, clientId, campaignId) {
    super(`accounts/${accountId}/clients/${clientId}/campaigns/${campaignId}/adz`)
  }

  // Here you can extend AccountClientCampaignAdzDB with custom methods
}
